<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Approval Management</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Property Update Approval Management" name="description" />
      <meta content="County Revenue System" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- tool bar -->
          <ToolBarValuation/>
          <!-- end of toolbar -->

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Approval Management Dashboard</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);" @click="gotTo('valuation-dashboard')">Valuation Roll</a></li>
                    <li class="breadcrumb-item active">Approvals</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Approval Statistics -->
          <div class="row mb-4">
            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Pending</p>
                      <h4 class="mb-0 text-warning">{{pendingCount.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                          <span class="avatar-title">
                            <i class="bx bx-time-five font-size-20"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Under Review</p>
                      <h4 class="mb-0 text-info">{{underReviewCount.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                          <span class="avatar-title">
                            <i class="bx bx-search-alt font-size-20"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Approved Today</p>
                      <h4 class="mb-0 text-success">{{approvedTodayCount.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-check-circle font-size-20"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">My Queue</p>
                      <h4 class="mb-0 text-primary">{{myQueueCount.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-user-check font-size-20"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Overdue</p>
                      <h4 class="mb-0 text-danger">{{overdueCount.toLocaleString()}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-danger">
                          <span class="avatar-title">
                            <i class="bx bx-error-circle font-size-20"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-2 col-md-4">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Avg Time</p>
                      <h4 class="mb-0 text-secondary">{{averageApprovalTime}}h</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-secondary">
                          <span class="avatar-title">
                            <i class="bx bx-timer font-size-20"></i>
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Quick Actions Bar -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h6 class="mb-0">
                        <i class="bx bx-zap text-warning me-2"></i>
                        Quick Actions
                      </h6>
                    </div>
                    <div class="col-md-6">
                      <div class="quick-actions text-md-end">
                        <button @click="selectAllPending" class="btn btn-sm btn-outline-primary me-2">
                          <i class="bx bx-select-multiple me-1"></i>Select All Pending
                        </button>
                        <button
                            @click="bulkApprove"
                            class="btn btn-sm btn-success me-2"
                            :disabled="selectedRequests.length === 0 || loading"
                        >
                          <i class="bx bx-check-double me-1"></i>
                          <span v-if="loading && bulkProcessing === 'approve'">Processing...</span>
                          <span v-else>Bulk Approve ({{selectedRequests.length}})</span>
                        </button>
                        <button
                            @click="bulkReject"
                            class="btn btn-sm btn-danger me-2"
                            :disabled="selectedRequests.length === 0 || loading"
                        >
                          <i class="bx bx-x me-1"></i>
                          <span v-if="loading && bulkProcessing === 'reject'">Processing...</span>
                          <span v-else>Bulk Reject ({{selectedRequests.length}})</span>
                        </button>
                        <button @click="refreshData" class="btn btn-sm btn-outline-secondary" :disabled="loading">
                          <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Debug Section (Remove in production) -->
          <div class="row mb-2" v-if="selectedRequests.length > 0">
            <div class="col-12">
              <div class="alert alert-info">
                <strong>Selected Requests ({{selectedRequests.length}}):</strong>
                <span v-for="(id, index) in selectedRequests" :key="id">
                  {{id}}<span v-if="index < selectedRequests.length - 1">, </span>
                </span>
                <button @click="selectedRequests = []" class="btn btn-sm btn-outline-secondary ms-2">Clear Selection</button>
              </div>
            </div>
          </div>

          <!-- Priority Queue -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card border-warning">
                <div class="card-header bg-warning text-dark">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">
                        <i class="bx bx-alarm me-2"></i>
                        Priority Queue
                      </h5>
                      <small>High priority and overdue requests requiring immediate attention</small>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <span class="badge bg-danger me-2">{{overdueCount}} Overdue</span>
                      <span class="badge bg-warning text-dark">{{priorityRequests.length}} Priority</span>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div v-if="priorityRequests.length === 0" class="text-center py-3">
                    <i class="bx bx-check-circle text-success" style="font-size: 2rem;"></i>
                    <p class="text-success mt-2 mb-0">All caught up! No priority requests at the moment.</p>
                  </div>
                  <div v-else class="table-responsive">
                    <table class="table table-sm mb-0">
                      <thead>
                      <tr>
                        <th width="5%">
                          <input type="checkbox" @change="toggleSelectAllPriority" :checked="allPrioritySelected">
                        </th>
                        <th width="15%">Reference</th>
                        <th width="15%">LR Number</th>
                        <th width="20%">Owner</th>
                        <th width="15%">Type</th>
                        <th width="10%">Priority</th>
                        <th width="10%">Days Old</th>
                        <th width="10%">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="request in priorityRequests" :key="request.id" :class="{'table-danger': isOverdue(request), 'table-warning': request.priority === 'high'}">
                        <td>
                          <input type="checkbox" :value="request.id" v-model="selectedRequests">
                        </td>
                        <td>
                          <span class="text-primary font-weight-bold">{{request.referenceNumber || request.reference_number || 'N/A'}}</span>
                        </td>
                        <td>{{request.LRNumber || 'N/A'}}</td>
                        <td>{{request.ownerNames || 'N/A'}}</td>
                        <td>
                          <span class="badge bg-soft-info text-info">{{getShortUpdateType(request.update_type)}}</span>
                        </td>
                        <td>
                            <span class="badge" :class="getPriorityBadge(request)">
                              {{getPriorityText(request)}}
                            </span>
                        </td>
                        <td>
                            <span :class="{'text-danger': isOverdue(request), 'text-warning': getDaysOld(request) > 3}">
                              {{getDaysOld(request)}} days
                            </span>
                        </td>
                        <td>
                          <div class="btn-group" role="group">
                            <button @click="quickApprove(request)" class="btn btn-sm btn-success" title="Quick Approve" :disabled="loading">
                              <i class="bx bx-check"></i>
                            </button>
                            <button @click="quickReject(request)" class="btn btn-sm btn-danger" title="Quick Reject" :disabled="loading">
                              <i class="bx bx-x"></i>
                            </button>
                            <button @click="showRequestDetails(request)" class="btn btn-sm btn-primary" title="View Details">
                              <i class="bx bx-eye"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Regular Approval Queue -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">
                        <i class="bx bx-list-check me-2"></i>
                        Approval Queue
                      </h5>
                      <small class="text-muted">All pending requests awaiting approval</small>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <div class="btn-group me-2" role="group">
                        <button @click="setQueueFilter('all')" class="btn btn-sm" :class="queueFilter === 'all' ? 'btn-primary' : 'btn-outline-primary'">All</button>
                        <button @click="setQueueFilter('pending')" class="btn btn-sm" :class="queueFilter === 'pending' ? 'btn-warning' : 'btn-outline-warning'">Pending</button>
                        <button @click="setQueueFilter('under_review')" class="btn btn-sm" :class="queueFilter === 'under_review' ? 'btn-info' : 'btn-outline-info'">Under Review</button>
                        <button @click="setQueueFilter('my_queue')" class="btn btn-sm" :class="queueFilter === 'my_queue' ? 'btn-secondary' : 'btn-outline-secondary'">My Queue</button>
                      </div>
                      <div class="btn-group" role="group">
                        <button @click="setSortBy('date_asc')" class="btn btn-sm" :class="sortBy === 'date_asc' ? 'btn-dark' : 'btn-outline-dark'">Oldest First</button>
                        <button @click="setSortBy('date_desc')" class="btn btn-sm" :class="sortBy === 'date_desc' ? 'btn-dark' : 'btn-outline-dark'">Newest First</button>
                        <button @click="setSortBy('priority')" class="btn btn-sm" :class="sortBy === 'priority' ? 'btn-dark' : 'btn-outline-dark'">Priority</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Quick Search -->
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <div class="input-group">
                        <input
                            v-model="searchTerm"
                            class="form-control"
                            type="text"
                            placeholder="Search reference, LR number, or owner..."
                            @keyup.enter="applyFilters"
                        >
                        <button @click="applyFilters" class="btn btn-primary">
                          <i class="bx bx-search"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <select v-model="filterUpdateType" @change="applyFilters" class="form-control">
                        <option value="">All Types</option>
                        <option value="Owner Information">Owner Info</option>
                        <option value="Property Details">Property Details</option>
                        <option value="Ownership Transfer">Transfer</option>
                        <option value="Property Improvements">Improvements</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <select v-model="perPage" @change="applyFilters" class="form-control">
                        <option value="25">25 per page</option>
                        <option value="50">50 per page</option>
                        <option value="100">100 per page</option>
                      </select>
                    </div>
                    <div class="col-md-4 text-end">
                      <button @click="exportApprovalQueue" class="btn btn-outline-success btn-sm me-2">
                        <i class="bx bx-export me-1"></i>Export Queue
                      </button>
                      <button @click="showApprovalSettings" class="btn btn-outline-secondary btn-sm">
                        <i class="bx bx-cog me-1"></i>Settings
                      </button>
                    </div>
                  </div>

                  <!-- Approval Queue Table -->
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0" v-if="!loading && approvalQueue.length > 0">
                      <thead class="table-dark">
                      <tr>
                        <th width="3%">
                          <input type="checkbox" @change="toggleSelectAll" :checked="allSelected">
                        </th>
                        <th width="12%">Reference</th>
                        <th width="12%">LR Number</th>
                        <th width="15%">Owner</th>
                        <th width="12%">Update Type</th>
                        <th width="8%">Status</th>
                        <th width="8%">Priority</th>
                        <th width="10%">Submitted</th>
                        <th width="8%">Days Old</th>
                        <th width="12%">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="request in paginatedQueue" :key="request.id"
                          :class="{
                              'table-danger': isOverdue(request),
                              'table-warning': request.priority === 'high',
                              'table-info': request.status === 'under_review' && request.assigned_to === currentUser
                            }">
                        <td>
                          <input type="checkbox" :value="request.id" v-model="selectedRequests">
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs me-2">
                                <span class="avatar-title rounded-circle" :class="getRequestIcon(request)">
                                  <i :class="getStatusIcon(request.status)"></i>
                                </span>
                            </div>
                            <div>
                              <h6 class="mb-0 text-primary">{{request.referenceNumber || request.reference_number || 'N/A'}}</h6>
                              <small class="text-muted">{{formatDate(request.submitted_date)}}</small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <strong>{{request.LRNumber || 'N/A'}}</strong>
                        </td>
                        <td>
                          <h6 class="mb-0">{{request.ownerNames || 'N/A'}}</h6>
                          <small class="text-muted">{{request.requesterPhone || 'No phone'}}</small>
                        </td>
                        <td>
                          <span class="badge bg-soft-info text-info">{{getShortUpdateType(request.update_type)}}</span>
                        </td>
                        <td>
                            <span class="badge" :class="getStatusBadge(request.status)">
                              {{(request.status || 'unknown').toUpperCase()}}
                            </span>
                        </td>
                        <td>
                            <span class="badge" :class="getPriorityBadge(request)">
                              {{getPriorityText(request)}}
                            </span>
                        </td>
                        <td>
                          <span>{{formatDate(request.submitted_date)}}</span><br>
                          <small class="text-muted">{{getTimeAgo(request.submitted_date)}}</small>
                        </td>
                        <td>
                            <span :class="{'text-danger': isOverdue(request), 'text-warning': getDaysOld(request) > 3}">
                              {{getDaysOld(request)}}
                            </span>
                        </td>
                        <td>
                          <div class="dropdown">
                            <button class="btn btn-sm btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                              <i class="bx bx-dots-vertical-rounded"></i>
                            </button>
                            <ul class="dropdown-menu">
                              <li><a class="dropdown-item" @click="quickApprove(request)"><i class="bx bx-check me-2 text-success"></i>Quick Approve</a></li>
                              <li><a class="dropdown-item" @click="quickReject(request)"><i class="bx bx-x me-2 text-danger"></i>Quick Reject</a></li>
                              <li><hr class="dropdown-divider"></li>
                              <li><a class="dropdown-item" @click="showRequestDetails(request)"><i class="bx bx-eye me-2"></i>View Details</a></li>
                              <li><a class="dropdown-item" @click="assignToMe(request)"><i class="bx bx-user-check me-2"></i>Assign to Me</a></li>
                              <li><a class="dropdown-item" @click="setPriority(request, 'high')"><i class="bx bx-error-circle me-2 text-warning"></i>Mark High Priority</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-3 mb-0">Loading approval queue...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-if="!loading && approvalQueue.length === 0" class="text-center py-5">
                      <i class="bx bx-check-circle text-success" style="font-size: 4rem;"></i>
                      <h5 class="mt-3 text-success">All Caught Up!</h5>
                      <p class="text-muted">No requests pending approval at the moment.</p>
                    </div>
                  </div>

                  <!-- Pagination -->
                  <div class="row mt-4" v-if="!loading && approvalQueue.length > 0">
                    <div class="col-md-6">
                      <p class="text-muted">
                        Showing {{(currentPage - 1) * perPage + 1}} to {{Math.min(currentPage * perPage, totalRequests)}} of {{totalRequests}} requests
                      </p>
                    </div>
                    <div class="col-md-6">
                      <nav>
                        <ul class="pagination justify-content-end mb-0">
                          <li class="page-item" :class="{disabled: currentPage === 1}">
                            <a class="page-link" @click="changePage(currentPage - 1)" href="javascript:void(0)">Previous</a>
                          </li>
                          <li
                              v-for="page in visiblePages"
                              :key="page"
                              class="page-item"
                              :class="{active: page === currentPage}"
                          >
                            <a class="page-link" @click="changePage(page)" href="javascript:void(0)">{{page}}</a>
                          </li>
                          <li class="page-item" :class="{disabled: currentPage === totalPages}">
                            <a class="page-link" @click="changePage(currentPage + 1)" href="javascript:void(0)">Next</a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Popup Modals -->
          <RequestDetailsModal
              v-if="showDetailsModal"
              :show="showDetailsModal"
              :request="selectedRequest"
              @close="closeDetailsModal"
              @approve="handleModalApprove"
              @reject="handleModalReject"
          />

          <!-- Bulk Action Modals -->
          <BulkApprovalModal
              v-if="showBulkApprovalModal"
              :show="showBulkApprovalModal"
              :requests="getSelectedRequestsData()"
              @close="closeBulkApprovalModal"
              @approve="handleBulkApprove"
          />

          <BulkRejectionModal
              v-if="showBulkRejectionModal"
              :show="showBulkRejectionModal"
              :requests="getSelectedRequestsData()"
              @close="closeBulkRejectionModal"
              @reject="handleBulkReject"
          />

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              ©{{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Approval Management System
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {paysol, biller, execute, execute2, executeDownload, getRight, landRate} from "@/api";
import moment from 'moment';
import ToolBarValuation from "@/components/valuation/ToolBar.vue";
import RequestDetailsModal from "@/components/valuation/RequestDetailsModal.vue";

export default {
  name: "ValuationApprovals",
  components: {ToolBarValuation, NavigationBar, RequestDetailsModal},

  data() {
    return {
      loading: false,
      bulkProcessing: null, // 'approve' or 'reject'

      // Statistics
      pendingCount: 0,
      underReviewCount: 0,
      approvedTodayCount: 0,
      myQueueCount: 0,
      overdueCount: 0,
      averageApprovalTime: 24,

      // Current user
      currentUser: sessionStorage.getItem("sessionNames"),

      // Queue management
      approvalQueue: [],
      priorityRequests: [],
      selectedRequests: [],
      queueFilter: 'pending',
      sortBy: 'date_asc',

      // Search and filters
      searchTerm: '',
      filterUpdateType: '',
      perPage: 25,
      currentPage: 1,
      totalRequests: 0,

      // Modals
      showDetailsModal: false,
      showBulkApprovalModal: false,
      showBulkRejectionModal: false,
      selectedRequest: null
    }
  },

  computed: {
    filteredQueue() {
      let filtered = [...this.approvalQueue];

      // Apply queue filter
      switch (this.queueFilter) {
        case 'pending':
          filtered = filtered.filter(req => req.status === 'pending');
          break;
        case 'under_review':
          filtered = filtered.filter(req => req.status === 'under_review');
          break;
        case 'my_queue':
          filtered = filtered.filter(req => req.assigned_to === this.currentUser);
          break;
      }

      // Apply search
      if (this.searchTerm) {
        const term = this.searchTerm.toLowerCase();
        filtered = filtered.filter(req =>
            (req.referenceNumber || req.reference_number || '').toLowerCase().includes(term) ||
            (req.LRNumber || '').toLowerCase().includes(term) ||
            (req.ownerNames || '').toLowerCase().includes(term)
        );
      }

      // Apply update type filter
      if (this.filterUpdateType) {
        filtered = filtered.filter(req => req.update_type?.includes(this.filterUpdateType));
      }

      // Apply sorting
      switch (this.sortBy) {
        case 'date_asc':
          filtered.sort((a, b) => new Date(a.submitted_date) - new Date(b.submitted_date));
          break;
        case 'date_desc':
          filtered.sort((a, b) => new Date(b.submitted_date) - new Date(a.submitted_date));
          break;
        case 'priority':
          filtered.sort((a, b) => {
            const priorityOrder = {'high': 3, 'medium': 2, 'low': 1};
            return (priorityOrder[b.priority] || 1) - (priorityOrder[a.priority] || 1);
          });
          break;
      }

      return filtered;
    },

    paginatedQueue() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + parseInt(this.perPage);
      return this.filteredQueue.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredQueue.length / this.perPage);
    },

    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 7) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 3) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push('...');
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
          pages.push('...');
          pages.push(total);
        }
      }

      return pages;
    },

    allSelected() {
      return this.paginatedQueue.length > 0 &&
          this.paginatedQueue.every(req => this.selectedRequests.includes(req.id));
    },

    allPrioritySelected() {
      return this.priorityRequests.length > 0 &&
          this.priorityRequests.every(req => this.selectedRequests.includes(req.id));
    }
  },

  mounted() {
    this.loadApprovalData();
    this.menuAccess();
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Approval Management");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {})
          .catch(() => {});
    },

    getRight(type) {
      return getRight(type);
    },

    async loadApprovalData() {
      this.loading = true;

      try {
        // Use existing function to get all update requests
        const data = new FormData();
        data.append("function", "getAllUpdateRequests");
        data.append("page", 1);
        data.append("perPage", 1000); // Get all requests for processing

        const response = await execute2(data, landRate);

        if (response.data.success) {
          const responseData = response.data.data;

          // Process the data to calculate statistics
          const allRequests = responseData.requests || [];

          // Calculate statistics
          this.pendingCount = allRequests.filter(req => req.status === 'pending').length;
          this.underReviewCount = allRequests.filter(req => req.status === 'under_review').length;
          this.overdueCount = allRequests.filter(req => this.isOverdue(req) && req.status !== 'approved' && req.status !== 'rejected').length;
          this.myQueueCount = allRequests.filter(req => req.assigned_to === this.currentUser || (req.status === 'under_review' && !req.assigned_to)).length;

          // Approved today count
          const today = moment().startOf('day');
          this.approvedTodayCount = allRequests.filter(req =>
              req.status === 'approved' &&
              req.processed_date &&
              moment(req.processed_date).isSameOrAfter(today)
          ).length;

          // Calculate average approval time (simplified)
          const approvedRequests = allRequests.filter(req => req.status === 'approved' && req.processed_date);
          if (approvedRequests.length > 0) {
            const totalHours = approvedRequests.reduce((sum, req) => {
              const submitted = moment(req.submitted_date);
              const processed = moment(req.processed_date);
              return sum + processed.diff(submitted, 'hours');
            }, 0);
            this.averageApprovalTime = Math.round(totalHours / approvedRequests.length);
          }

          // Filter for approval queue (pending and under review)
          this.approvalQueue = allRequests.filter(req =>
              req.status === 'pending' || req.status === 'under_review' || req.status === 'requires_documents'
          );

          // Priority requests (overdue + high priority)
          this.priorityRequests = this.approvalQueue.filter(req =>
              this.isOverdue(req) || req.priority === 'high'
          ).slice(0, 10); // Limit to top 10 priority items

          this.totalRequests = this.approvalQueue.length;

          console.log('Loaded approval data:', {
            total: allRequests.length,
            approvalQueue: this.approvalQueue.length,
            priorityRequests: this.priorityRequests.length,
            pendingCount: this.pendingCount
          });

        } else {
          console.error('Failed to load approval data:', response.data.message);
          alert('Failed to load approval data: ' + response.data.message);
        }
      } catch (error) {
        console.error('Error loading approval data:', error);
        alert('Error loading approval data. Please try again.');
      } finally {
        this.loading = false;
      }
    },

    // Debug method for troubleshooting
    debugRequestData(request) {
      console.log('Request object:', request);
      console.log('Request keys:', Object.keys(request || {}));
      console.log('Request ID:', request?.id);
      console.log('Reference Number:', request?.referenceNumber || request?.reference_number);
      console.log('Full approval queue:', this.approvalQueue);
      console.log('Priority requests:', this.priorityRequests);
    },

    // Helper method to remove request from local arrays for immediate UI update
    removeRequestFromArrays(requestId) {
      // Remove from approval queue
      const queueIndex = this.approvalQueue.findIndex(req => req.id === requestId);
      if (queueIndex !== -1) {
        this.approvalQueue.splice(queueIndex, 1);
      }

      // Remove from priority requests
      const priorityIndex = this.priorityRequests.findIndex(req => req.id === requestId);
      if (priorityIndex !== -1) {
        this.priorityRequests.splice(priorityIndex, 1);
      }

      // Remove from selected requests if it was selected
      const selectedIndex = this.selectedRequests.findIndex(id => id === requestId);
      if (selectedIndex !== -1) {
        this.selectedRequests.splice(selectedIndex, 1);
      }

      // Update counts immediately
      this.pendingCount = Math.max(0, this.pendingCount - 1);
      this.approvedTodayCount += 1;
      this.totalRequests = this.approvalQueue.length;
    },

    // Queue filtering and sorting
    setQueueFilter(filter) {
      this.queueFilter = filter;
      this.currentPage = 1;
    },

    setSortBy(sort) {
      this.sortBy = sort;
      this.currentPage = 1;
    },

    applyFilters() {
      this.currentPage = 1;
    },

    // Selection management
    toggleSelectAll() {
      if (this.allSelected) {
        // Deselect all visible items
        this.paginatedQueue.forEach(req => {
          const index = this.selectedRequests.indexOf(req.id);
          if (index > -1) {
            this.selectedRequests.splice(index, 1);
          }
        });
      } else {
        // Select all visible items
        this.paginatedQueue.forEach(req => {
          if (!this.selectedRequests.includes(req.id)) {
            this.selectedRequests.push(req.id);
          }
        });
      }
    },

    toggleSelectAllPriority() {
      const priorityIds = this.priorityRequests.map(req => req.id);
      if (this.allPrioritySelected) {
        this.selectedRequests = this.selectedRequests.filter(id => !priorityIds.includes(id));
      } else {
        priorityIds.forEach(id => {
          if (!this.selectedRequests.includes(id)) {
            this.selectedRequests.push(id);
          }
        });
      }
    },

    selectAllPending() {
      const pendingIds = this.approvalQueue.filter(req => req.status === 'pending').map(req => req.id);
      this.selectedRequests = pendingIds;
      console.log('Selected all pending requests:', pendingIds);
    },

    // Quick actions - FIXED METHODS
    async quickApprove(request) {
      // Add debugging
      this.debugRequestData(request);

      // Validate request object
      if (!request) {
        console.error('Request is null or undefined');
        alert('Invalid request: Request object is missing');
        return;
      }

      // Validate required properties
      if (!request.id) {
        console.error('Request ID is missing:', request);
        alert('Invalid request: Request ID is missing');
        return;
      }

      // Get reference number from either field
      const referenceNumber = request.referenceNumber || request.reference_number;
      if (!referenceNumber) {
        console.error('Reference number is missing:', request);
        alert('Invalid request: Reference number is missing');
        return;
      }

      // Show confirmation dialog with proper reference number
      if (!confirm(`Are you sure you want to approve request ${referenceNumber}?`)) {
        return;
      }

      // Show loading state
      this.loading = true;

      try {
        const data = new FormData();
        data.append("function", "approveUpdateRequest");
        data.append("requestId", request.id);
        data.append("adminUser", this.currentUser);
        data.append("adminIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("notes", "Quick approval from approval dashboard");

        const response = await execute2(data, landRate);

        if (response.data.success) {
          // Show success message
          if (this.$toast) {
            this.$toast.success('Request approved successfully!');
          } else {
            alert('Request approved successfully!');
          }

          // Remove the approved request from the current arrays to update UI immediately
          this.removeRequestFromArrays(request.id);

          // Reload data to get updated statistics
          await this.loadApprovalData();

        } else {
          alert('Error approving request: ' + (response.data.message || 'Unknown error'));
        }
      } catch (error) {
        console.error('Error approving request:', error);
        alert('Failed to approve request. Please try again.');
      } finally {
        this.loading = false;
      }
    },

    async quickReject(request) {
      // Validate request object
      if (!request) {
        console.error('Request is null or undefined');
        alert('Invalid request: Request object is missing');
        return;
      }

      // Validate required properties
      if (!request.id) {
        console.error('Request ID is missing:', request);
        alert('Invalid request: Request ID is missing');
        return;
      }

      // Get reference number from either field
      const referenceNumber = request.referenceNumber || request.reference_number;
      if (!referenceNumber) {
        console.error('Reference number is missing:', request);
        alert('Invalid request: Reference number is missing');
        return;
      }

      const reason = prompt(`Enter rejection reason for ${referenceNumber}:`);
      if (!reason || reason.trim() === '') {
        return;
      }

      this.loading = true;

      try {
        const data = new FormData();
        data.append("function", "rejectUpdateRequest");
        data.append("requestId", request.id);
        data.append("adminUser", this.currentUser);
        data.append("adminIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("reason", reason.trim());

        const response = await execute2(data, landRate);

        if (response.data.success) {
          if (this.$toast) {
            this.$toast.success('Request rejected successfully!');
          } else {
            alert('Request rejected successfully!');
          }

          // Remove the rejected request from arrays
          this.removeRequestFromArrays(request.id);

          // Reload data
          await this.loadApprovalData();

        } else {
          alert('Error rejecting request: ' + (response.data.message || 'Unknown error'));
        }
      } catch (error) {
        console.error('Error rejecting request:', error);
        alert('Failed to reject request. Please try again.');
      } finally {
        this.loading = false;
      }
    },

    // FIXED BULK OPERATIONS
    async bulkApprove() {
      console.log('bulkApprove called with selectedRequests:', this.selectedRequests);

      if (this.selectedRequests.length === 0) {
        alert('Please select requests to approve');
        return;
      }

      // Show confirmation dialog
      if (!confirm(`Are you sure you want to approve ${this.selectedRequests.length} selected requests?`)) {
        return;
      }

      this.loading = true;
      this.bulkProcessing = 'approve';

      try {
        const data = new FormData();
        data.append("function", "bulkApproveRequests");
        data.append("requestIds", JSON.stringify(this.selectedRequests));
        data.append("adminUser", this.currentUser);
        data.append("adminIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("notes", 'Bulk approval from dashboard');

        console.log('Sending bulk approve request:', {
          function: "bulkApproveRequests",
          requestIds: this.selectedRequests,
          adminUser: this.currentUser
        });

        const response = await execute2(data, landRate);

        console.log('Bulk approve response:', response);

        if (response.data.success) {
          const result = response.data.data;
          alert(`Successfully approved ${result.approvedCount} of ${result.totalRequests} requests`);

          // Clear selections and reload data
          this.selectedRequests = [];
          await this.loadApprovalData();

          // Show toast if available
          if (this.$toast) {
            this.$toast.success(`Bulk approval completed: ${result.approvedCount} requests approved`);
          }
        } else {
          alert('Error in bulk approval: ' + (response.data.message || 'Unknown error'));
        }
      } catch (error) {
        console.error('Error in bulk approval:', error);
        alert('Failed to process bulk approval. Please try again.');
      } finally {
        this.loading = false;
        this.bulkProcessing = null;
      }
    },

    async bulkReject() {
      console.log('bulkReject called with selectedRequests:', this.selectedRequests);

      if (this.selectedRequests.length === 0) {
        alert('Please select requests to reject');
        return;
      }

      // Get rejection reason
      const reason = prompt(`Enter rejection reason for ${this.selectedRequests.length} selected requests:`);
      if (!reason || reason.trim() === '') {
        return;
      }

      // Show confirmation dialog
      if (!confirm(`Are you sure you want to reject ${this.selectedRequests.length} selected requests?`)) {
        return;
      }

      this.loading = true;
      this.bulkProcessing = 'reject';

      try {
        const data = new FormData();
        data.append("function", "bulkRejectRequests");
        data.append("requestIds", JSON.stringify(this.selectedRequests));
        data.append("adminUser", this.currentUser);
        data.append("adminIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("reason", reason.trim());

        console.log('Sending bulk reject request:', {
          function: "bulkRejectRequests",
          requestIds: this.selectedRequests,
          adminUser: this.currentUser,
          reason: reason.trim()
        });

        const response = await execute2(data, landRate);

        console.log('Bulk reject response:', response);

        if (response.data.success) {
          const result = response.data.data;
          alert(`Successfully rejected ${result.rejectedCount} of ${result.totalRequests} requests`);

          // Clear selections and reload data
          this.selectedRequests = [];
          await this.loadApprovalData();

          // Show toast if available
          if (this.$toast) {
            this.$toast.success(`Bulk rejection completed: ${result.rejectedCount} requests rejected`);
          }
        } else {
          alert('Error in bulk rejection: ' + (response.data.message || 'Unknown error'));
        }
      } catch (error) {
        console.error('Error in bulk rejection:', error);
        alert('Failed to process bulk rejection. Please try again.');
      } finally {
        this.loading = false;
        this.bulkProcessing = null;
      }
    },

    // Enhanced handleBulkApprove for modal-based approval
    async handleBulkApprove(approvalData) {
      if (this.selectedRequests.length === 0) {
        alert('No requests selected for approval');
        return;
      }

      this.loading = true;

      try {
        const data = new FormData();
        data.append("function", "bulkApproveRequests");
        data.append("requestIds", JSON.stringify(this.selectedRequests));
        data.append("adminUser", this.currentUser);
        data.append("adminIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("notes", approvalData?.notes || 'Bulk approval via modal');

        const response = await execute2(data, landRate);

        if (response.data.success) {
          const result = response.data.data;

          // Close modal
          this.closeBulkApprovalModal();

          // Show success message
          alert(`Successfully approved ${result.approvedCount} of ${result.totalRequests} requests`);

          // Clear selections and reload data
          this.selectedRequests = [];
          await this.loadApprovalData();

        } else {
          alert('Error in bulk approval: ' + (response.data.message || 'Unknown error'));
        }
      } catch (error) {
        console.error('Error in bulk approval:', error);
        alert('Failed to process bulk approval. Please try again.');
      } finally {
        this.loading = false;
      }
    },

    // Enhanced handleBulkReject for modal-based rejection
    async handleBulkReject(rejectionData) {
      if (this.selectedRequests.length === 0) {
        alert('No requests selected for rejection');
        return;
      }

      this.loading = true;

      try {
        const data = new FormData();
        data.append("function", "bulkRejectRequests");
        data.append("requestIds", JSON.stringify(this.selectedRequests));
        data.append("adminUser", this.currentUser);
        data.append("adminIdNo", sessionStorage.getItem("sessionIdNo"));
        data.append("reason", rejectionData?.reason || 'Bulk rejection via modal');

        const response = await execute2(data, landRate);

        if (response.data.success) {
          const result = response.data.data;

          // Close modal
          this.closeBulkRejectionModal();

          // Show success message
          alert(`Successfully rejected ${result.rejectedCount} of ${result.totalRequests} requests`);

          // Clear selections and reload data
          this.selectedRequests = [];
          await this.loadApprovalData();

        } else {
          alert('Error in bulk rejection: ' + (response.data.message || 'Unknown error'));
        }
      } catch (error) {
        console.error('Error in bulk rejection:', error);
        alert('Failed to process bulk rejection. Please try again.');
      } finally {
        this.loading = false;
      }
    },

    // Utility methods
    getDaysOld(request) {
      return moment().diff(moment(request.submitted_date), 'days');
    },

    isOverdue(request) {
      return this.getDaysOld(request) > 5; // Consider 5+ days as overdue
    },

    getPriorityText(request) {
      if (this.isOverdue(request)) return 'OVERDUE';
      return (request.priority || 'medium').toUpperCase();
    },

    getPriorityBadge(request) {
      if (this.isOverdue(request)) return 'bg-danger text-white';
      const badges = {
        'high': 'bg-warning text-dark',
        'medium': 'bg-info text-white',
        'low': 'bg-secondary text-white'
      };
      return badges[request.priority] || 'bg-info text-white';
    },

    getShortUpdateType(updateType) {
      if (!updateType) return 'Unknown';
      const types = updateType.split(', ');
      if (types.length === 1) return types[0];
      return `${types[0]} +${types.length - 1}`;
    },

    getStatusBadge(status) {
      const badges = {
        'pending': 'bg-warning text-dark',
        'under_review': 'bg-info text-white',
        'approved': 'bg-success text-white',
        'rejected': 'bg-danger text-white',
        'requires_documents': 'bg-secondary text-white'
      };
      return badges[status] || 'bg-secondary text-white';
    },

    getRequestIcon(request) {
      if (this.isOverdue(request)) return 'bg-danger text-white';
      if (request.priority === 'high') return 'bg-warning text-dark';
      return 'bg-primary text-white';
    },

    getStatusIcon(status) {
      const icons = {
        'pending': 'bx bx-time-five',
        'under_review': 'bx bx-search-alt',
        'approved': 'bx bx-check-circle',
        'rejected': 'bx bx-x-circle',
        'requires_documents': 'bx bx-file-blank'
      };
      return icons[status] || 'bx bx-circle';
    },

    getSelectedRequestsData() {
      return this.approvalQueue.filter(req => this.selectedRequests.includes(req.id));
    },

    // Modal management
    showRequestDetails(request) {
      this.selectedRequest = request;
      this.showDetailsModal = true;
    },

    closeDetailsModal() {
      this.showDetailsModal = false;
      this.selectedRequest = null;
    },

    closeBulkApprovalModal() {
      this.showBulkApprovalModal = false;
    },

    closeBulkRejectionModal() {
      this.showBulkRejectionModal = false;
    },

    handleModalApprove(request) {
      this.quickApprove(request);
      this.closeDetailsModal();
    },

    handleModalReject(request) {
      this.quickReject(request);
      this.closeDetailsModal();
    },

    // Additional actions
    async assignToMe(request) {
      try {
        const data = new FormData();
        data.append("function", "assignRequest");
        data.append("requestId", request.id);
        data.append("assignedTo", this.currentUser);

        const response = await execute2(data, landRate);

        if (response.data.success) {
          alert('Request assigned to you successfully!');
          this.loadApprovalData();
        } else {
          alert('Error assigning request: ' + response.data.message);
        }
      } catch (error) {
        console.error('Error assigning request:', error);
      }
    },

    async setPriority(request, priority) {
      try {
        const data = new FormData();
        data.append("function", "updateRequestPriority");
        data.append("requestId", request.id);
        data.append("priority", priority);

        const response = await execute2(data, landRate);

        if (response.data.success) {
          alert(`Request priority updated to ${priority}!`);
          this.loadApprovalData();
        } else {
          alert('Error updating priority: ' + response.data.message);
        }
      } catch (error) {
        console.error('Error updating priority:', error);
      }
    },

    // Export and settings
    exportApprovalQueue() {
      const headers = ['Reference', 'LR Number', 'Owner', 'Update Type', 'Status', 'Priority', 'Days Old', 'Submitted Date'];
      const rows = [headers.join(',')];

      this.filteredQueue.forEach((request) => {
        const row = [
          `"${request.referenceNumber || request.reference_number || 'N/A'}"`,
          `"${request.LRNumber || 'N/A'}"`,
          `"${request.ownerNames || 'N/A'}"`,
          `"${request.update_type || 'N/A'}"`,
          request.status || 'unknown',
          request.priority || 'medium',
          this.getDaysOld(request),
          moment(request.submitted_date).format('YYYY-MM-DD HH:mm')
        ];
        rows.push(row.join(','));
      });

      const csvContent = rows.join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `approval_queue_${moment().format('YYYY-MM-DD')}.csv`;
      link.click();
    },

    showApprovalSettings() {
      alert('Approval settings feature coming soon!');
    },

    refreshData() {
      this.loadApprovalData();
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== '...') {
        this.currentPage = page;
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD/MM/YYYY');
    },

    getTimeAgo(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).fromNow();
    },

    gotTo(route) {
      router.push(route);
    }
  }
}
</script>

<style scoped>
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.mini-stats-wid:hover {
  transform: translateY(-2px);
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.table-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
}

.table-warning {
  background-color: rgba(255, 193, 7, 0.1) !important;
}

.table-info {
  background-color: rgba(23, 162, 184, 0.1) !important;
}

.quick-actions .btn {
  transition: all 0.3s ease;
}

.quick-actions .btn:hover {
  transform: translateY(-1px);
}

.priority-queue .card {
  border-left: 4px solid #ffc107;
}

.btn-group .btn {
  border-radius: 4px;
}

.pagination .page-link {
  cursor: pointer;
}

.dropdown-toggle::after {
  display: none;
}

@media (max-width: 768px) {
  .quick-actions {
    text-align: center !important;
    margin-top: 15px;
  }

  .quick-actions .btn {
    margin-bottom: 5px;
    width: 100%;
  }

  .btn-group {
    display: block;
    width: 100%;
  }

  .btn-group .btn {
    width: 100%;
    margin-bottom: 5px;
  }
}
</style>